<template>
    <div>
        <Header/>
        <router-view></router-view>
        <Footer/>
    </div>
</template>

<script>
import Header from './Header/Header'
import Footer from './Footer/Footer'

export default {
    name: 'Servicios',
    components: {
        Header,
        Footer
    },
    data() {
        return {

        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/servicios.vue